import { genDefaultName } from '@zephyr3d/device';
import { Disposable } from '@zephyr3d/base';

let _uniqueId = 0;
class WebGLGPUObject extends Disposable {
    _device;
    _object;
    _uid;
    _cid;
    _name;
    _restoreHandler;
    constructor(device){
        super();
        this._device = device;
        this._object = null;
        this._uid = ++_uniqueId;
        this._cid = 1;
        this._name = genDefaultName(this);
        this._restoreHandler = null;
        this._device.addGPUObject(this);
    }
    get device() {
        return this._device;
    }
    get object() {
        return this._object;
    }
    get restoreHandler() {
        return this._restoreHandler;
    }
    set restoreHandler(handler) {
        this._restoreHandler = handler;
    }
    get uid() {
        return this._uid;
    }
    get cid() {
        return this._cid;
    }
    get name() {
        return this._name;
    }
    set name(val) {
        if (val !== this._name) {
            const lastName = this._name;
            this._name = val;
            this._device.dispatchEvent('gpuobject_rename', this, lastName);
        }
    }
    isVertexLayout() {
        return false;
    }
    isFramebuffer() {
        return false;
    }
    isSampler() {
        return false;
    }
    isTexture() {
        return false;
    }
    isTexture2D() {
        return false;
    }
    isTexture2DArray() {
        return false;
    }
    isTexture3D() {
        return false;
    }
    isTextureCube() {
        return false;
    }
    isTextureVideo() {
        return false;
    }
    isProgram() {
        return false;
    }
    isBuffer() {
        return false;
    }
    isBindGroup() {
        return false;
    }
    reload() {
        if (this.disposed) {
            this._device.restoreObject(this);
            this._cid++;
        }
    }
    destroy() {
        throw new Error('Abstract function call: destroy()');
    }
    restore() {
        throw new Error('Abstract function call: restore()');
    }
    onDispose() {
        super.onDispose();
        this._device.disposeObject(this, true);
    }
}

export { WebGLGPUObject };
//# sourceMappingURL=gpuobject_webgl.js.map
